<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login-ifm.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-5 text-center">
                  <h4 class="text-primary">Willkommen zur neuen IFM</h4>
                  <h4 class="mb-4 text-primary">SERVICE APP</h4>
                  <small>Exklusive entwickelt fur optimiertes Arbeiten</small>
                </div>
                <div>
                  <vs-tabs>
                    <vs-tab label="Super Admin">
                      <div class="con-tab-ejemplo">
                        <vs-input
                          v-validate="'required|email|min:3'"
                          data-vv-validate-on="blur"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email Super Admin"
                          v-model="superadmin.email"
                          class="w-full"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("email")
                        }}</span>

                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="superadmin.password"
                          class="w-full mt-6"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("password")
                        }}</span>

                        <div class="flex flex-wrap justify-between my-5">
                          <!-- <router-link to="/pages/forgot-password"
                            >Forgot Password?</router-link
                          > -->
                        </div>
                        <div class="flex flex-wrap justify-between mb-3">
                          <!-- <vs-button type="border" @click="registerUser"
                            >Register</vs-button
                          > -->
                          <vs-button
                            :disabled="!validateForm"
                            @click="loginSuper"
                            >Login</vs-button
                          >
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Fachbereichsleiter">
                      <div class="con-tab-ejemplo">
                        <vs-input
                          v-validate="'required|email|min:3'"
                          data-vv-validate-on="blur"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email Fachbereichsleiter"
                          v-model="admin.email"
                          class="w-full"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("email")
                        }}</span>

                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="admin.password"
                          class="w-full mt-6"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("password")
                        }}</span>

                        <div class="flex flex-wrap justify-between my-5">
                          <!-- <router-link to="/pages/forgot-password"
                            >Forgot Password?</router-link
                          > -->
                        </div>
                        <div class="flex flex-wrap justify-between mb-3">
                          <!-- <vs-button type="border" @click="registerUser"
                            >Register</vs-button
                          > -->
                          <vs-button
                            :disabled="!validateForm"
                            @click="loginAdmin"
                            >Login</vs-button
                          >
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Kunde">
                      <div class="con-tab-ejemplo">
                        <vs-input
                          v-validate="'required|email|min:3'"
                          data-vv-validate-on="blur"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email Kunde"
                          v-model="customer.email"
                          class="w-full"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("email")
                        }}</span>

                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="customer.password"
                          class="w-full mt-6"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("password")
                        }}</span>

                        <div class="flex flex-wrap justify-between my-5">
                          <!-- <router-link to="/pages/forgot-password"
                            >Forgot Password?</router-link
                          > -->
                        </div>
                        <div class="flex flex-wrap justify-between mb-3">
                          <!-- <vs-button type="border" @click="registerUser"
                            >Register</vs-button
                          > -->
                          <vs-button
                            :disabled="!validateForm"
                            @click="loginCustomer"
                            >Login</vs-button
                          >
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Fachkraft">
                      <div class="con-tab-ejemplo">
                        <vs-input
                          v-validate="'required|email|min:3'"
                          data-vv-validate-on="blur"
                          name="email"
                          icon-no-border
                          icon="icon icon-user"
                          icon-pack="feather"
                          label-placeholder="Email Fachkraft"
                          v-model="worker.email"
                          class="w-full"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("email")
                        }}</span>

                        <vs-input
                          data-vv-validate-on="blur"
                          v-validate="'required|min:6|max:10'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          label-placeholder="Password"
                          v-model="worker.password"
                          class="w-full mt-6"
                        />
                        <span class="text-danger text-sm">{{
                          errors.first("password")
                        }}</span>

                        <div class="flex flex-wrap justify-between my-5">
                          <!-- <router-link to="/pages/forgot-password"
                            >Forgot Password?</router-link
                          > -->
                        </div>
                        <div class="flex flex-wrap justify-between mb-3">
                          <!-- <vs-button type="border" @click="registerUser"
                            >Register</vs-button
                          > -->
                          <vs-button
                            :disabled="!validateForm"
                            @click="loginWorker"
                            >Login</vs-button
                          >
                        </div>
                      </div>
                    </vs-tab>
                  </vs-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
export default {
  data () {
    return {
      admin: {
        email: '',
        password: ''
      },
      superadmin: {
        email: '',
        password: ''
      },
      customer: {
        email: '',
        password: ''
      },
      worker: {
        email: '',
        password: ''
      },
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.email !== '' && this.password !== ''
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginSuper () {

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.superadmin.email,
          password: this.superadmin.password
        }
      }

      this.$store
        .dispatch('auth/loginSuper', payload)
        .then(() => {
          this.$router.push('/dashboard/super')
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Credentials not found',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    loginAdmin () {

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.admin.email,
          password: this.admin.password
        }
      }

      this.$store
        .dispatch('auth/loginAdmin', payload)
        .then(() => {
          this.$router.push('/dashboard/admin')
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Credentials not found',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    loginCustomer () {

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.customer.email,
          password: this.customer.password
        }
      }

      this.$store
        .dispatch('auth/loginCustomer', payload)
        .then(() => {
          this.$router.push('/dashboard/customer')
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Credentials not found',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    loginWorker () {

      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.worker.email,
          password: this.worker.password
        }
      }

      this.$store
        .dispatch('auth/loginWorker', payload)
        .then(() => {
          this.$router.push('/dashboard/worker')
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Credentials not found',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    registerUser () {
      if (!this.checkLogin()) return
      this.$router.push('/pages/register').catch(() => {})
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
